export enum ERROR_CODES {
  UNPROCESSABLE_ENTITY = 422,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_ERROR = 500,
  BAD_GATEWAY = 502,
  GATEWAY_TIMEOUT = 504,
}

export enum ERROR_MESSAGES {
  MAX_ORG_USERS_REACHED = 'If you add this space you will reach the max capacity of users of the Organisation. Please disable or remove some users to be able to continue',
  MAX_COLLABORATORS_REACHED = 'Please upgrade to a higher plan. The limit of possible collaborators has been reached',
}
